<div fxLayout="row" fxLayoutGap="10px">
  <div fxLayout="row" fxLayoutAlign="center center">
    <mat-icon class="warning-icon">warning</mat-icon>
  </div>

  <div fxLayout="row" fxLayoutAlign="start start" fxLayoutGap="12px">
    <div fxLayout="column" fxFlex>
      <div fxLayout="row" fxLayoutAlign="space-between start">
        <mat-icon class="close-btn" (click)="onClose()">close</mat-icon>
      </div>
      <div fxLayout="row" fxLayoutAlign="start center" fxLayoutGap="12px">
        <div fxLayout="column">
          <div class="title">{{ data.title }}</div>
          <div>{{ data.message }}</div>
        </div>
        @if (data.showContinue !== false) {
          <div fxLayout="row" fxLayoutAlign="end center" style="margin-top: 8px;">
            <button mat-button class="continue-btn btn-outline-dark field-height-button" (click)="onContinue()">CONTINUE</button>
          </div>
        }
      </div>
    </div>
  </div>
</div>
